import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { RadiosDataService } from 'src/app/services/radios-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription, of, interval, BehaviorSubject } from 'rxjs';
import { Category } from 'src/app/models/category';
import { CategoryService } from 'src/app/services/category.service';
import * as firebase from 'firebase';
import { RadioService } from 'src/app/services/radio.service';
import { Radio } from 'src/app/models/radio';
import { map, take } from 'rxjs/operators';
import { Program } from 'src/app/models/program';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NewsService } from 'src/app/services/news.service';
import { News } from 'src/app/models/news';
import { HttpClient } from '@angular/common/http';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AnalitycsService } from 'src/app/services/analitycs.service';

export interface PeriodicElement {
  video: string;
  position: number;
  description: string;
  title: string;
  date: string;
}

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.scss']
})
export class HomeNewComponent implements OnInit {

  @HostListener('window:beforeunload', ['$event'])
  unloadAnalytics($event: any) {
    this.analytics.logEvents("refresh: home");
  }

  texto: string = "Ver estaciones de radio";
  radios: Radio[];
  radioFM961 = true;
  radioUniversal = false;
  radioAM247 = false;
  playlistONOFF = false;
  subscription: Subscription;
  audioRadio: any;
  value = 100;
  paused;
  paused2;
  paused3;

  contador = 10;
  breakpoint: number;
  bigbreakpoint: number;

  city: string;
  country: string;

  categorias: Observable<Category[]>;

  dateactuall: Date;
  radiosPlaying: Radio[];
  actualPlaynig: Radio = null;
  Subscription: Subscription = new Subscription();
  radioProgram: Program;
  news: Observable<News[]> = of(null);
  newss: News[] = [];
  newsOberserver : BehaviorSubject<News[]> = new BehaviorSubject([]);
  noticiaActual: News;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public serviceRadio: RadiosDataService,
    private radioServ: RadioService,
    public sanitizer: DomSanitizer,
    private categoryServ: CategoryService,
    private newsServ: NewsService,
    private http: HttpClient,
    public radiosDataService: RadiosDataService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private analytics: AnalitycsService
  ) {
    this.analytics.logEvents("Home");
    this.mobileQuery = media.matchMedia('(max-width: 991px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.radioAM247 = this.radiosDataService.RADIOAM247;
    this.radioFM961 = this.radiosDataService.RADIOFM961;
    this.radioUniversal = this.radiosDataService.RADIOUNIVERSAL;
    this.playlistONOFF = this.radiosDataService.PLAYLISTONOFF;
    this.radioServ.getVisible().then(radios => this.radios = radios);

    this.categoryServ.getVisible().then(categorias => {
      this.categorias = of(categorias.sort(this.sortByName));
    })


    this.dateactuall = firebase.firestore.Timestamp.now().toDate();

    this.newsServ.getVisible().then(news => {
      this.newss = news.slice(0, 3);
      this.newsOberserver.next(this.newss);
      this.noticiaActual = this.newss[0];
    })
  }

  sortByName(a, b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  ngOnDestroy(): void {
    this.Subscription.unsubscribe();
  }

  nextPageToken;
  ytvideolist = [];
  ytPrimerVideo;
  longitud = 2;

  ngOnInit(): void {
   this.Subscription.add(
      this.serviceRadio.getPlayer().subscribe((radio) => {

        this.radioServ.getVisible().then(radios => {
          this.radiosPlaying = radios;

          if (this.radiosPlaying) {
            this.actualPlaynig = this.radiosPlaying[radio];
          }
        });
      })
    );
    this.Subscription.add(interval(1000)
      .pipe(
        map((tick) => {
          this.dateactuall = new Date(
            this.dateactuall.setSeconds(this.dateactuall.getSeconds() + 1)
          );
          this.setProgram(this.dateactuall);

          return tick;
        })
      )
      .subscribe());

    this.breakpoint = (window.innerWidth <= 991) ? 0 : 5;
    this.bigbreakpoint = (window.innerWidth <= 991) ? 15 : 5;
  }

  openCategory(id){
    this.router.navigate(['noticias/' + id]);
  }

  openNews(id){
    this.analytics.logEvents("Reciente: "+id);
    this.router.navigate(['noticia/' + id]);
  }


  setProgram(time: Date) {

    let hour = time.getHours();
    let minutes = time.getMinutes();
    let day = time.getDay();
    if (this.actualPlaynig) {
      switch (day) {
        case 0: this.setProgramDay(hour, minutes, this.actualPlaynig.sunday);
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 5: this.setProgramDay(hour, minutes, this.actualPlaynig.programLV);
          break;
        case 6: this.setProgramDay(hour, minutes, this.actualPlaynig.saturday);
          break;
        default:
          break;
      }
    }

  }
  setProgramDay(hour: number, minutes: number, programs: Program[]) {
    let selected: Program;
    programs.forEach(prog => {
      if (this.compare(prog.starttime, hour, minutes) && !this.compare(prog.endtime, hour, minutes)) {
        selected = prog;
      }
    });
    this.radioProgram = selected;
  }

  compare(time: NgbTimeStruct, hour: number, minute: number) {
    let hourtime = time.hour
    let minutetime = time.minute;

    minutetime += hourtime * 60;
    minute += hour * 60;

    return minute >= minutetime;

  }

  ngAfterContentInit() {
    window.scroll(0, 0);
  }

  verifyRadioOption(value: string) {
    switch (value) {
      case 'fm96.1':
        this.radioFM961 = true;
        this.radioUniversal = false;
        this.radioAM247 = false
        this.radiosDataService.RADIOAM247 = false;
        this.radiosDataService.RADIOFM961 = true;
        this.radiosDataService.RADIOUNIVERSAL = false;
        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Centro FM 96.1 MHz";
        this.stopAudioAux();

        break;
      case 'universal':
        this.radioUniversal = true;
        this.radioFM961 = false;
        this.radioAM247 = false;

        this.radiosDataService.RADIOAM247 = false;
        this.radiosDataService.RADIOFM961 = false;
        this.radiosDataService.RADIOUNIVERSAL = true;

        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Universal 106.9 MHz"
        this.stopAudioAux();
        break;
      case 'am24.7':
        this.radioAM247 = true
        this.radioUniversal = false;
        this.radioFM961 = false;

        this.radiosDataService.RADIOAM247 = true;
        this.radiosDataService.RADIOFM961 = false;
        this.radiosDataService.RADIOUNIVERSAL = false;

        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Centro AM 1420 kHz"
        this.stopAudioAux();
        break;

      default:
        break;
    }
  }

  stopAudioAux() {
    this.audioRadio = document.getElementById('audioaux');
    if (this.audioRadio != undefined) {
      this.audioRadio.pause();
      this.audioRadio.src = "";
    }
  }

  sliderOnChange(number: any) {
    let covertToVolume = number * 0.01;
    this.audioRadio.volume = covertToVolume;
  }

  verifyRadioToPlay() {
    if (this.radioAM247) {

      this.radiosDataService.RADIOAM247 = true;
      this.radiosDataService.RADIOFM961 = false;
      this.radiosDataService.RADIOUNIVERSAL = false;

      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playCentroAM();
    }
    else if (this.radioFM961) {
      this.radiosDataService.RADIOAM247 = false;
      this.radiosDataService.RADIOFM961 = true;
      this.radiosDataService.RADIOUNIVERSAL = false;
      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playCentroFM();
    }
    else if (this.radioUniversal) {
      this.radiosDataService.RADIOAM247 = false;
      this.radiosDataService.RADIOFM961 = false;
      this.radiosDataService.RADIOUNIVERSAL = true;

      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playradioUniversal();
    }
  }

  public pause(): void {
    this.radiosDataService.pause();
    this.paused = false;
    this.paused2 = false;
    this.paused3 = false;
    this.radiosDataService.PLAYLISTONOFF = false;

    this.radiosDataService.setRadioUniversal(false);
    this.radiosDataService.setRadioCenAM(false);
    this.radiosDataService.setRadioCenFM(false);
  }

  izquierda() {
    this.contador--;
    if (this.contador == 0) {
      this.contador += 7;
    }
  }

  derecha() {
    this.contador++;
  }

  contasum(num) {
    if ((this.contador % this.newss.length + num) > 2)
      return (this.contador % this.newss.length + num - 3);
    else
      return (this.contador % this.newss.length + num);
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 991) ? 0 : 5;
    this.bigbreakpoint = (event.target.innerWidth <= 991) ? 15 : 5;
  }
}
